import agents from '../assets/agents.json';

export type Agent = {
    head: string;
    body: string;
    happy: string;
    sleep: string;
};

export const useAgent = () => {
    let arr: Agent[] = [];

    agents.forEach(element => {
        const obj = {
            head: window.location.origin + `/agents/${element.name}/head.png`,
            body: window.location.origin + `/agents/${element.name}/body.png`,
            happy: window.location.origin + `/agents/${element.name}/happy.png`,
            sleep: window.location.origin + `/agents/${element.name}/sleep.png`
        };
        arr.push(obj);
    });

    return arr;
};
